import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { parseError } from '../shared/error';
import { internalLayersKeys } from './queryKeys';
import type {
  CreateInternalLayerBody,
  InternalLayer,
} from 'hooks/internalLayer/types';
import { layerNodesKeys } from 'hooks/layerNode/queryKeys';

export function useCreateInternalLayerMutation() {
  const queryClient = useQueryClient();

  return useMutation<InternalLayer, unknown, CreateInternalLayerBody>({
    mutationFn: async (input: CreateInternalLayerBody) => {
      const resp = await axios.post<InternalLayer>(
        config.apiGateway.internal_layers,
        input
      );

      return resp.data;
    },
    onSuccess: () => {
      toast.success('Internal layer created');
    },
    onError: (error) => {
      toast.error(parseError(error));
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: internalLayersKeys.all() });
      queryClient.invalidateQueries({ queryKey: layerNodesKeys.all() });
    },
  });
}
